import React, { useState, useEffect } from 'react';
import {
	Row,
	Col,
	Breadcrumb,
	Card,
	Space,
	Select,
	Input,
	Button,
	Table,
	Spin,
	message,
} from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { fetchAdminApi } from '../../../../services/api';
import constants from '../../../../constants/constants';
import { getCustomisedBreadcrumbs } from '../../../../functions/functions';
import useAntdClearButtonA11y from '../../../../custom hooks/useAntdClearButtonA11y';

const { Option } = Select;
const { Search } = Input;

function ChapterwiseMediaList({
	apiEndpoint,
	fetchPreview,
	columns,
	onAddRoute,
	pageTitle,
	pageCrumb,
	dataKey = 'data',
}) {
	const [messageApi, contextHolder] = message.useMessage();
	const location = useLocation();
	const navigate = useNavigate();
	useAntdClearButtonA11y();
	const [chapterId, setChapterId] = useState(location?.state?.chapterId || '');
	const [chapterList, setChapterList] = useState([]);
	const [mediaList, setMediaList] = useState([]);
	const [filteredData, setFilteredData] = useState([]);
	const [inputVal, setInputVal] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const [recordCount, setRecordCount] = useState(0);

	const breadcrumb = [
		<Link key="main" to={`/${pageCrumb}`} className="font-semibold">{pageTitle}</Link>,
		<span key="current" className="font-semibold !text-black">{pageTitle} List</span>
	];

	useEffect(() => {
		getChapters();
	}, []);

	useEffect(() => {
		if (chapterId) fetchMediaByChapter();
	}, [chapterId]);

	const getChapters = async () => {
		const res = await fetchAdminApi('/chapters-list', 'get');
		if (res?.data?.length > 0) {
			const options = res.data.map((c, i) => ({ value: (i + 1).toString(), label: c.chapter }));
			localStorage.setItem('chapterDetails', JSON.stringify(options));
			setChapterList(options);
		}else{
			setChapterList([]);
		}
	};

	const fetchMediaByChapter = async () => {
		setIsLoading(true);
		const res = await fetchAdminApi(`${apiEndpoint}?chapter_id=${chapterId}`, 'get');
		if (res?.[dataKey]) {
			setMediaList(res[dataKey]);
			setFilteredData(res[dataKey]);
			setRecordCount(res[dataKey].length);
		} else {
			setMediaList([]);
			setFilteredData([]);
			setRecordCount(0);
		}
		setIsLoading(false);
	};

	const handleSearch = (value) => {
		if (!value) {
			setFilteredData(mediaList);
			return;
		}
		const filtered = mediaList.filter(item =>
			item.caption?.toLowerCase().includes(value.toLowerCase())
		);
		setFilteredData(filtered);
	};

	const handleAddClick = () => {
		navigate(`${onAddRoute}`, {
			state: {
				data: [
					{
						chaptervalue: chapterId,
						allChapters: chapterList
					}
				]
			}
		});
	};
	const onChangeChapter = (id) => {
		setChapterId(id);
		setInputVal("");
	};

	return (
		<Row>
			<Col span={24}>
				<div className="p-4 min-h-screen bg-gray-100">
					<Breadcrumb items={getCustomisedBreadcrumbs(constants.flashCardpageCrumbs, breadcrumb)} className="bg-neutral-100 shadow-md p-3" />
					<Card>
						<Space className="flex-space">
							<Select
								value={chapterId}
								onChange={onChangeChapter}
								className="w-80"
								placeholder="Select Chapter"
							>
								{chapterList.map(c => (
									<Option key={c.value} value={c.value}>{c.label}</Option>
								))}
							</Select>
							<Search
								value={inputVal}
								onChange={(e) => setInputVal(e.target.value)}
								onSearch={handleSearch}
								placeholder="Search by caption"
								enterButton
								className="searchBtn w-80"
							/>
							<Button type="primary" onClick={handleAddClick} className="addFlashbtn w-32 font-semibold" >
								<PlusOutlined /> Add {pageTitle}
							</Button>
						</Space>
						{contextHolder}
					</Card>

					<div className="font-semibold mb-3 text-sm pl-3 mt-3">
						{recordCount} {constants.recordCount}
					</div>

					<Table
						bordered
						columns={columns(fetchPreview)}
						dataSource={filteredData}
						pagination={false}
						loading={{ spinning: isLoading, indicator: <Spin /> }}
						scroll={{ x: 768 }}
						locale={{ emptyText: constants.emptyTableText }}
						title={() => <div className="font-bold tracking-wide text-lg pl-3 flashTableTitle">{pageTitle.toUpperCase()}</div>}
						size="middle"
						rowKey="resource_file_id"
						className="mt-3"
					/>
				</div>
			</Col>
		</Row>
	);
}

export default ChapterwiseMediaList;
